import { createSlice } from '@reduxjs/toolkit';
import { TicketCategoryState } from './ticketCategoryTypes';
import {
    createTicketCategory,
    fetchTicketCategoryById,
    fetchTicketAllCategories,
    updateTicketCategory,
    deleteTicketCategory,
    fetchTicketCategorySummary,
    fetchTicketCategorySummaryByDepartment
} from './ticketCategoryActions';

const initialState: TicketCategoryState = {
    TicketsCategories: [],
    TicketCategorySummry: [],
    TicketCategorySummryByDepartment: [],
    selectedCategory: undefined,
    loading: false,
    error: undefined,
};

const ticketCategorySlice = createSlice({
    name: 'ticketCategory',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Ticket Category
            .addCase(createTicketCategory.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createTicketCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketsCategories.push(action.payload);
            })
            .addCase(createTicketCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Ticket Category by ID
            .addCase(fetchTicketCategoryById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketCategoryById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedCategory = action.payload;
            })
            .addCase(fetchTicketCategoryById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Ticket Categories
            .addCase(fetchTicketAllCategories.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketAllCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketsCategories = action.payload.data;
            })
            .addCase(fetchTicketAllCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchTicketCategorySummary.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketCategorySummary.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketCategorySummry = action.payload.data;
            })
            .addCase(fetchTicketCategorySummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Ticket Category
            .addCase(updateTicketCategory.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateTicketCategory.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.TicketsCategories.findIndex(category => category.id === action.payload.id);
                if (index !== -1) {
                    state.TicketsCategories[index] = action.payload;
                }
            })
            .addCase(updateTicketCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchTicketCategorySummaryByDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketCategorySummaryByDepartment.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketCategorySummryByDepartment = action.payload.data;
            })
            .addCase(fetchTicketCategorySummaryByDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Ticket Category
            .addCase(deleteTicketCategory.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteTicketCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketsCategories = state.TicketsCategories.filter((category: any) => category.id !== action.payload.id);
            })
            .addCase(deleteTicketCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default ticketCategorySlice.reducer;
